import React from 'react';
import dotenv from 'dotenv';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import { createStubbedServer } from 'server';

import { createRoot } from 'react-dom/client';
import './index.scss';

dotenv.config();

// TODO: remove this when we have a working backend deployed
// if (process.env.NODE_ENV !== 'production') {
//createStubbedServer();
// }

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// reportWebVitals();

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
